module.exports = __webpack_public_path__ + "assets/img/HH_Parc Canberra EC_RGB_lr.ff6ffb99.jpg";